import { ICardProps } from './types'
import generateCommonProps from './generateCommonProps'
import clsx from 'clsx'
import styles from './styles.module.scss'

const Card = ({
  asList = false,
  children,
  className = 'mui-card',
  disabled = false,
  id,
  onClick,
  size = 'md',
  style,
  transparent = false,
  ...props
}: ICardProps) => {
  const handleClick = () => {
    if (onClick && !disabled) {
      onClick()
    }
  }

  const commonProps = generateCommonProps({
    children,
    className: clsx(className, {
      [styles.hasHover]: onClick,
      [styles.disabled]: disabled,
      [styles.transparent]: transparent,
    }),
    disabled,
    id,
    size,
    style: {
      ...style,
      userSelect: onClick ? 'none' : undefined,
    },
    ...props,
  })

  const role = onClick ? 'button' : asList ? 'listitem' : 'region'

  return asList ? (
    <li
      data-testid="mui-card"
      {...commonProps}
      aria-hidden={disabled}
      onClick={() => handleClick()}
      role={role}
    >
      {children}
    </li>
  ) : (
    <div
      data-testid="mui-card"
      {...commonProps}
      aria-hidden={disabled}
      onClick={() => handleClick()}
      role={role}
    >
      {children}
    </div>
  )
}

export default Card
